import React from "react";

const Details = ({ rowData }) => {
  const fields = [
    { label: "ID", key: "id" },
    { label: "Transaction ID", key: "transactionId" },
    { label: "Amount", key: "amount" },
    { label: "Completion DateTime", key: "completionDateTime" },
    { label: "Core Wallet ID", key: "coreWalletId" },
    { label: "Created By", key: "createdById" },
    { label: "Created Date", key: "createdDate" },
    { label: "Customer Mobile Number", key: "customerMobileNumber" },
    { label: "Kiosk Name", key: "kioskName" },
    { label: "Recipient Mobile Number", key: "recipientMobileNumber" },
    { label: "Remarks", key: "remarks" },
    { label: "Transaction Status", key: "status" },
    { label: "Transaction Type", key: "transactionType" },
  ];

  return (
    <div className="main-form">
      <div className="p-fluid formgrid grid">
        {fields.map(({ label, key }) => (
          <div key={key} className="field col-12 md:col-4 mb-3">
            <label>{label}</label>
            <p>{rowData[key] || "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
